import { baseApi } from './baseApi';

export const saasApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTenants: builder.query({
      query: () => '/saas/tenants',
      providesTags: ['Tenant'],
    }),
    onboardTenant: builder.mutation({
      query: (body) => ({
        url: '/saas/onboard',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Tenant'],
    }),
    toggleTenantStatus: builder.mutation({
      query: ({ id, isActive }) => ({
        url: `/saas/tenants/${id}/status`,
        method: 'PATCH',
        body: { isActive },
      }),
      invalidatesTags: ['Tenant', 'Company'],
    }),
  }),
});

export const {
  useGetTenantsQuery,
  useOnboardTenantMutation,
  useToggleTenantStatusMutation,
} = saasApi;
